import { useState, useEffect } from "react";
import TextField from "../../Components/UI/Inputs/TextField.js";
import Password from "../../Components/UI/Inputs/Password.js";
import Button from "../../Components/UI/Buttons/Button";
import DropDown from "../../Components/UI/Inputs/DropDown.js";
import showToast from "../../Helpers/toast";
import useApi from "../../Hooks/useApi";
import ErrorHandler from "../../Components/Shared/ErrorHandler.js";
import { handleApiError } from "../../Helpers/ErrorHandler.js";


const Register = () => {


  const initialFormState = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    designationId: 0,
    departmentId: 0,
  };



  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [formData, setFormData] = useState(initialFormState);

  const { request, error } = useApi({ isPublic: true });

  const fetchDepartments = async () => {
    try {
      const response = await request("GET", `/v1/departments`, {})
      
      setDepartments(response);  // Assuming res.data contains an array of departments
    } catch (error) {
      console.log(error);
      handleApiError(error);
    }
  };
  const fetchDesignations = async () => {
    try {
      const response = await request("GET", `/v1/designations`, {});
      setDesignations(response);  // Assuming res.data contains an array of designations
    } catch (error) {
      console.log(error);
      handleApiError(error);
    }
  };
  useEffect(() => {
    fetchDepartments();
    fetchDesignations();
  }, []);

  const handleInputChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    let data = { ...formData };
    if (data.password !== data.confirmPassword) {
      return "passwords do not match";
    }
    if (
      !data.email
        ?.trim()
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      return "invalid email";
    }
    delete data.confirmPassword;
    return data;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = validate();

    if (typeof(data)==='object') {
      try {
        const res = await request('POST', '/v1/auth/register', {
          data: {
            ...data,
            designationId: data?.designationId, departmentId: data?.departmentId
          }
        })
        showToast({ message: res?.message });
        setTimeout(() => {
          window.location.replace("/login")
        }, 1500);
        
      } catch (error) {
        showToast({ message: error?.response?.data?.message, type: 'error' });
      }
    } else {
      showToast({ message: data ||"Please fill out all required fields.", type: 'error' });
    }
    // Reset the form
    // setFormData(initialFormState);
  };

  
  if (error) {
    return <ErrorHandler errors={error} />;
  }
  return (
    <div className="px-2 w-full overflow-auto ">
      <h2 className="text-title">Create an Account</h2>

      <div className="container-inner  
        grid lg:grid-cols-2 gap-3  ">
        <TextField
          label="First Name"
          name="firstName"
          onValueChange={handleInputChange}
          value={formData.firstName}
        />

        <TextField
          label="Middle Name"
          name="middleName"
          onValueChange={handleInputChange}
          value={formData.middleName}
        />

        <TextField
          label="Last Name"
          name="lastName"
          onValueChange={handleInputChange}
          value={formData.lastName}
        />

        <DropDown
          label="Department"
          name="departmentId"
          placeholder={"Select Department"}
          options={departments?.length ? departments?.map(el => ({ name: el.name, value: el.id })) : []}
          onValueChange={(value) =>
            handleInputChange("departmentId", value)
          }
          value={formData.departmentId}
        />

        <DropDown
          label="Designation"
          name="designationId"
          placeholder={"Select Designation"}
          options={designations?.length ? designations?.map(el => ({ name: el.name, value: el.id })) : []}

          onValueChange={(value) =>
            handleInputChange("designationId", value)
          }
          value={formData.designationId}
        />

        <TextField
          label="Email"
          name="email"
          onValueChange={handleInputChange}
          value={formData.email}
        />

        

        <Password
          label="Password"
          name="password"
          onValueChange={handleInputChange}
          value={formData.password}
        />

        <Password
          label="Confirm Password"
          name="confirmPassword"
          onValueChange={handleInputChange}
          value={formData.confirmPassword}
        />

        <div className="col-span-full">
          <Button
            type="full"
            label="Submit"
            textColor="white"
            backgroundColor="#7DDBFF"
            handler={handleSubmit}
            style={{ width: "100%", marginTop: "24px" }}
          />
        </div>
      </div>

    </div>
  );
};

export default Register;